import { useCrypto } from '@/libs/crypto'
import { EHR_LOGGED_USER, useStorage } from '@/libs/storage'

import { User } from '../models/user.model'

const useCachedUser = () => {
  const { setItem, getItem, removeItem } = useStorage(EHR_LOGGED_USER)
  const { encrypt, decrypt } = useCrypto()
  const getUser = (): User | null => {
    const user = getItem()

    if (!user) {
      return null
    }

    return JSON.parse(decrypt(user))
  }

  const setUser = (user: User) => {
    const encryptUser = encrypt(JSON.stringify(user))
    setItem(encryptUser)
  }

  const removeUser = () => {
    removeItem()
  }

  return {
    getUser,
    setUser,
    removeUser
  }
}

export default useCachedUser
